export default function weightedAverage(scores: number[], weights: number[]): number {
  if (scores.length !== weights.length) throw new Error('Scores and weights must have the same length');

  const sum = scores.reduce((acc, score, i) => acc + score * weights[i], 0);
  const totalWeight = weights.reduce((acc, w) => acc + w, 0);
  return sum / totalWeight;
}
